export { default } from './Footer';
export type { FooterProps } from './Footer';
